<template lang="pug">
.reservation-message-modal
  b-modal(v-model="_value" size="xl" no-close-on-backdrop no-close-on-esc @ok="ok" @cancel="cancel")
    template(#modal-title)
      span 以下の面会予約を一括承諾します。よろしいですか？

    ReservationTable.reservation-table(v-model="items" :fields="fields")

    template(#modal-footer="{ ok, cancel }")
      b-button.btn.modal-ok-btn(@click="ok") OK
      b-button.btn.modal-cancel-btn(@click="cancel") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import ReservationTable, { ReservationTableField, ReservationTableItem } from "@/pc/containers/reservations/ReservationTable.vue";

/**
 * ### メッセージ送信内容入力モーダル
 */
@Component({
  components: {
    ReservationTable
  }
})
export default class MessageModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** 面会予約各行の情報 */
  @Prop()
  items!: Array<ReservationTableItem>;

  /** 面会予約列名 */
  fields: Array<ReservationTableField> = [];

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    const fields: Array<ReservationTableField> = this.createReservationFields();
    this.fields = fields;
    return;
  }

  /**
   * ### 面会予約の列を作成する
   */
  public createReservationFields(): Array<ReservationTableField> {
    let fields: Array<ReservationTableField> = [];

    fields.push({ key: "type", label: "種別", sortable: false, sortDirection: "desc", class: "text-center type" });
    fields.push({ key: "modalDatetime", label: "面会日時", sortable: false, sortDirection: "desc", class: "modal-date" });
    fields.push({ key: "modalResident", label: "利用者名（部屋名）", sortable: false, sortDirection: "desc", class: "modal-resident" });
    fields.push({ key: "modalFamilyName", label: "面会者名（続柄）", sortable: false, sortDirection: "desc", class: "modal-family-name" });

    return fields;
  }

  public async ok(): Promise<void> {
    this.$emit("ok");
    return;
  }

  public cancel(): void {
    this.$emit("cancel");
    return;
  }
}

export enum TestMailTargetType {
  /** 種別無し */
  NONE = 0,
  /** 家族ユーザー */
  FAMILY = 1,
  /** 施設関係者 */
  OTHER_USER_GROUP_MEMBER = 2
}
</script>
